import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children, requireAdmin = false }) => {
  const { isAuthenticated, isAdmin, loading, user } = useAuth();

  console.log('🛡️ ProtectedRoute Check:', {
    isAuthenticated,
    isAdmin,
    loading,
    requireAdmin,
    user: user?.username,
    userRole: user?.role?.name,
  });

  if (loading) {
    return <div className="loading-container">Loading...</div>;
  }

  if (!isAuthenticated) {
    console.warn('⚠️ User not authenticated, redirecting to login');
    return <Navigate to="/login" replace />;
  }

  if (requireAdmin && !isAdmin) {
    console.warn('⚠️ User is not admin, redirecting to dashboard', {
      requireAdmin,
      isAdmin,
      userRole: user?.role?.name,
    });
    return <Navigate to="/dashboard" replace />;
  }

  console.log('✅ Access Granted');
  return children;
};
